import { render } from "./ChartByTypeBlocks.vue?vue&type=template&id=76347ddc"
import script from "./ChartByTypeBlocks.vue?vue&type=script&lang=js"
export * from "./ChartByTypeBlocks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__